import moment from 'moment'

export function getDataTimeRange(datasets) {
  var allStartDate = datasets.map(x => moment(x.FirstRecordDate).valueOf())
  var allEndDate = datasets.map(x => moment(x.LastRecordDate).valueOf())
  var minDate = Math.min.apply(Math, allStartDate)
  var maxDate = Math.max.apply(Math, allEndDate)
  return [moment(minDate), moment(maxDate)]
}

export function getTotalNumberOfRecords(datasets) {
  var total = datasets.map(x => x.NumberOfRecords).reduce((a, b) => a + b, 0)
  return total
}

export function getTotalNumberOfRecordsWithDepthHeight(datasets) {
  if (!datasets) return 0

  var total = datasets.map(x => x.NumberOfRecordsWithDepthHeight).reduce((a, b) => a + b, 0)
  return total
}